import React, { useState, useEffect } from "react";
import "./EmployeeAdd.css";
import DashNav from "../../Components/DashNav/DashNav";
import EmployeeSVG from "../../Components/SVGS/EmployeeSVG";
import InputField from "../../Components/InputField/InputField";
// import Select from "react-select";
import Gbtn from "../../Components/buttons/Gbtn";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";

function EmployeeAdd({ isEdit }) {
  const icon = () => {
    return <EmployeeSVG size="22" fill="black" />;
  };

  //Toast messages
  const showMessage = (cat) => {
    cat === 0
      ? toast.success("Employee Added Successfuly!", {
          position: toast.POSITION.BOTTOM_RIGHT,
        })
      : cat === 1
      ? toast.error("Employee Not Added! Some Error occurred", {
          position: toast.POSITION.BOTTOM_RIGHT,
        })
      : toast.error("Network Error!", {
          position: toast.POSITION.TOP_CENTERR,
        });
  };

  // const [resetFormFields, setResetFormFields] = useState({
  //   email: "",
  //   password: "",
  //   first_name: "",
  //   last_name: "",
  //   gender: NaN,
  //   dob: "",
  //   salary: 0,
  // })

  const [opt, setopt] = useState([
    { value: "dept1", label: "dept1" },
    { value: "dept1", label: "dept4" },
    { value: "dept1", label: "dept3" },
    { value: "dept1", label: "dept2" },
  ]);
  const [statusOpt, setStatusOpt] = useState([
    { value: "1", label: "active" },
    { value: "0", label: "disable" },
  ]);
  const [genderOpt, setGenderOpt] = useState([
    { value: "1", label: "Male" },
    { value: "0", label: "Female" },
    { value: "3", label: "Other" },
  ]);

  const location = useLocation();
  const empEdit =
    location.state && location.state.employeeToEdit
      ? location.state.employeeToEdit
      : null;
  const employeeEdit = empEdit && empEdit.employee;

  //Employee Edit code

  // console.log("empedit:",empEdit)
  // console.log("employeedit:",employeeEdit)

  const [selectedStatus, setselectedStatus] = useState(
    isEdit && employeeEdit.status === 1 ? "1" : "0"
  );

  const handleTypeSelect = (e) => {
    setselectedStatus(e.value);
  };
  const handlegenderSelect = (e) => {
    setGender(e.value);
  };

  const empUpdateOnclick = () => {
    setIsErr(false);
    setIsLoading(true);
    employee.gender = parseInt(gender);
    employee.status = parseInt(selectedStatus);
    user.name = employee.first_name + " " + employee.last_name;
    employee.user = user;

    // updateEmployee(employee).then(({data})=>{
    //   setIsLoading(false)
    //   if (data.success){
    //     showMessage(0)
    //     navigate('/dashboard/employees', {state:{Message: 'Successfull!'}})
    //   }
    //   else{
    //     showMessage(1)
    //     setIsErr(true)
    //     setErrMsg(data.message)
    //   }
    //   }).catch((err)=>{
    //     showMessage(2)
    //     setIsErr(true)
    //     setErrMsg(err.message)
    //   })
  };

  //Employee Add code

  const [user, setUser] = useState({
    id: isEdit ? empEdit.id : 0,
    email: isEdit ? empEdit.email : "",
    name: isEdit ? empEdit.name : "",
    password: isEdit ? empEdit.password : "",
    is_verified: isEdit ? empEdit.is_verified : 1,
    role_id: 4,
  });

  const [pass, setPass] = useState("");
  const [gender, setGender] = useState(
    empEdit && empEdit ? (employeeEdit.gender === 1 ? "1" : "0") : ""
  );
  const [confrmPass, setConfrmPass] = useState("");
  const [err, setErr] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isErr, setIsErr] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [employee, setEmployee] = useState({
    user: { ...user },
    id: isEdit ? employeeEdit.id : 0,
    user_id: isEdit ? employeeEdit.user_id : 0,
    description: "",
    first_name: isEdit ? employeeEdit.first_name : "",
    last_name: isEdit ? employeeEdit.last_name : "",
    gender: isEdit ? employeeEdit.gender : NaN,
    dob: isEdit ? (dob) => new Date(employeeEdit.dob) : "",
    status: isEdit ? employeeEdit.status : 1,
    salary: isEdit ? employeeEdit.salary : 0,
    action_type: isEdit ? employeeEdit.action_type : 1,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmployee({
      ...employee,
      [name]: value,
    });
  };
  const handleUserChange = (e) => {
    const { name, value } = e.target;
    setUser({
      ...user,
      [name]: value,
    });
  };
  const handleGenderSelection = (e) => {
    setGender(e.target.value);
  };

  const navigate = useNavigate("");

  const addEmployeeClick = () => {
    setErr(false);
    setIsErr(false);
    setIsLoading(true);
    // if(pass === confrmPass) {
    //   user.password = pass
    //   user.name = employee.first_name + ' ' + employee.last_name;
    //   employee.gender = parseInt(gender)
    //   employee.user = user
    //   addEmployee(employee).then(({data})=>{
    //     setIsLoading(false)
    //     if (data.success){
    //       showMessage(0)
    //       navigate('/dashboard/employees')
    //     }
    //     else{
    //       setIsErr(true)
    //       setErrMsg(data.message)
    //       showMessage(1)
    //     }
    //     }).catch((err)=>{
    //       showMessage(2)
    //       setIsLoading(false)
    //       setIsErr(true)
    //       setErrMsg(err.message)
    //     })
    //   }
    //   else {
    //     setErr(true)
    //     setIsLoading(false)
    //   }
  };

  const discardOnlclick = () => {
    navigate("/dashboard/employees");
  };

  return (
    <>
      {isEdit ? (
        <div className="mainDashView">
          <div>
            <DashNav
              svg={icon}
              DashboardNavText={
                isEdit
                  ? `Employee Edit > ${employee.first_name}`
                  : "Employee > Add"
              }
            />
          </div>
          <div className="dashPanel ae-formArea">
            <div
              style={{
                color: "red",
                display: isErr ? "felx" : "none",
                textAlign: "center",
              }}
            >
              Error!{errMsg}
            </div>
            {isLoading ? (
              <div style={{ width: "100%", textAlign: "center" }}>
                <LoadingSpinner />
              </div>
            ) : (
              <div className="ae-form">
                <div className="ae-formFields">
                  <div className="ae-inputField">
                    <InputField
                      cat="First Name"
                      name={"first_name"}
                      value={employee.first_name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="ae-inputField">
                    <InputField
                      cat="Last Name"
                      name={"last_name"}
                      value={employee.last_name}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="ae-formFields">
                  <div className="ae-inputField">
                    <InputField
                      cat="Email"
                      type="email"
                      name={"email"}
                      value={user.email}
                      onChange={handleUserChange}
                    />
                  </div>
                  <div className="ae-inputField">
                    <div
                      className="ae-selectText"
                      style={{ marginTop: "20px" }}
                    >
                      Gender
                    </div>
                    {/* <Select
                      options={genderOpt}
                      onChange={handlegenderSelect}
                      value={genderOpt.filter(function (option) {
                        return option.value === gender;
                      })}
                      placeholder="Gender"
                      className="ae-select"
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          backgroundColor: state.isFocused
                            ? "white"
                            : "#F5F6FA",
                          border: "none",
                          marginLeft: "-8px",
                          marginRight: "7px",
                          borderRadius: "20px",
                          fontSize: "14px",
                          padding: "0px 10px",
                        }),
                      }}
                    /> */}
                  </div>
                </div>
                {/* <div className='ae-formFields'>
                <div className='ae-inputField'>
                  <InputField value = {employeeEdit.username} cat = 'Username'/>
                </div>
                <div className='ae-inputField'>
                  <div className='ae-selectText'>Department</div>
                    <Select options={opt} placeholder="Department" className='ae-select'
                        styles={{
                            control: (baseStyles, state) => ({
                            ...baseStyles,
                            backgroundColor: state.isFocused ?"white":'#F5F6FA',
                            border: 'none',
                            marginLeft: '-8px',
                            marginRight: '7px',
                            borderRadius: '20px',
                            fontSize: "14px",
                            padding:"0px 10px",
                            }),
                        }}
                    />
                </div>
              </div> */}
                <div className="ae-formFields">
                  <div className="ae-inputField">
                    <InputField
                      cat="Date of Birth"
                      type="date"
                      name={"dob"}
                      value={employee.dob}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="ae-inputField">
                    <InputField
                      cat="Salary"
                      type="number"
                      name={"salary"}
                      value={employee.salary}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="ae-inputField">
                  <div className="ae-selectText" style={{ marginTop: "20px" }}>
                    Status
                  </div>
                  {/* <Select
                    options={statusOpt}
                    onChange={handleTypeSelect}
                    value={statusOpt.filter(function (option) {
                      return option.value === selectedStatus;
                    })}
                    placeholder="Status"
                    className="ae-select"
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: state.isFocused ? "white" : "#F5F6FA",
                        border: "none",
                        borderRadius: "20px",
                        marginLeft: "8px",
                        marginRight: "0px",
                        fontSize: "14px",
                        padding: "0px",
                      }),
                    }}
                  /> */}
                </div>
                {/* <div className='ae-formFields'>
                <div className='ae-inputField'>
                  <div className='ae-selectText'>Role</div>
                  <Select options={opt} placeholder="Role" className='ae-select'
                      styles={{
                          control: (baseStyles, state) => ({
                          ...baseStyles,
                          backgroundColor: state.isFocused ?"white":'#F5F6FA',
                          border: 'none',
                          borderRadius: '20px',
                          marginLeft: '8px',
                          marginRight: '0px',
                          fontSize: "14px",
                          padding:"0px",
                          }),
                      }}
                  />
                </div>
                <div className='ae-inputField'>
                  <div className='ae-selectText'>Status</div>
                    <Select options={opt} placeholder="Status" className='ae-select'
                        styles={{
                            control: (baseStyles, state) => ({
                            ...baseStyles,
                            backgroundColor: state.isFocused ?"white":'#F5F6FA',
                            border: 'none',
                            marginLeft: '-8px',
                            marginRight: '7px',
                            borderRadius: '20px',
                            fontSize: "14px",
                            padding:"0px",
                            }),
                        }}
                    />
                </div>
              </div> */}
                {/* <div className='ae-formFields'>
                <div className='ae-inputField'>
                  <InputField cat = 'Password' placeholder = 'Password' type = 'password' />
                </div>
                <div className='ae-inputField'>
                  <InputField placeholder = 'Confirm Password' type = 'password'/>
                </div>
              </div> */}
              </div>
            )}
            <div>
              <div className="ev-btnAdd ev-btn">
                <Gbtn
                  text="Update"
                  func={empUpdateOnclick}
                  color="#4ab493"
                  radius="13px"
                  width="130px"
                />
              </div>
              <div className="ev-btnDel ev-btn">
                <Gbtn
                  text="Discard"
                  color="#F39971"
                  radius="13px"
                  width="130px"
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="mainDashView">
          <div>
            <DashNav svg={icon} DashboardNavText="Employees > Add Employees" />
          </div>
          <div className="dashPanel ae-formArea">
            <div
              style={{
                color: "red",
                display: isErr ? "felx" : "none",
                textAlign: "center",
              }}
            >
              Error!{errMsg}
            </div>
            {isLoading ? (
              <div style={{ width: "100%", textAlign: "center" }}>
                <LoadingSpinner />
              </div>
            ) : (
              <div className="ae-form" style={{ paddingRight: "40px" }}>
                <div className="ae-formFields">
                  <div className="ae-inputField">
                    <InputField
                      placeholder="First Name"
                      name="first_name"
                      value={employee.first_name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="ae-inputField">
                    <InputField
                      placeholder="Last Name"
                      name="last_name"
                      value={employee.last_name}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="ae-formFields">
                  <div className="ae-inputField">
                    <InputField
                      placeholder="Email"
                      type="email"
                      name="email"
                      value={user.email}
                      onChange={handleUserChange}
                    />
                  </div>
                  <div className="ae-inputField ae-gender-input">
                    <div className="ae-gender-input-text">Gender</div>
                    <div className="ae-gender-radio">
                      <label>
                        <input
                          type="radio"
                          checked={gender === "1"}
                          name="gender"
                          value={"1"}
                          onChange={handleGenderSelection}
                        />
                        Male
                      </label>
                      <label>
                        <input
                          type="radio"
                          checked={gender === "0"}
                          name="gender"
                          value={"0"}
                          onChange={handleGenderSelection}
                        />
                        Female
                      </label>
                      <label>
                        <input
                          type="radio"
                          checked={gender === "3"}
                          name="gender"
                          value={"3"}
                          onChange={handleGenderSelection}
                        />
                        Other
                      </label>
                    </div>
                  </div>
                </div>
                {/* <div className='ae-formFields'>
                <div className='ae-inputField'>
                  <InputField placeholder = 'Refered By'/>
                </div>
                <div className='ae-inputField'>
                  <div className='ae-selectText'>Department</div>
                    <Select options={opt} placeholder="Department" className='ae-select'
                        styles={{
                            control: (baseStyles, state) => ({
                            ...baseStyles,
                            backgroundColor: state.isFocused ?"white":'#F5F6FA',
                            border: 'none',
                            marginLeft: '-8px',
                            marginRight: '7px',
                            borderRadius: '20px',
                            fontSize: "14px",
                            padding:"0px 10px",
                            }),
                        }}
                    />
                </div>
              </div> */}
                <div className="ae-formFields">
                  <div className="ae-inputField">
                    <InputField
                      placeholder="Date of birth"
                      type="date"
                      name={"dob"}
                      value={employee.dob}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="ae-inputField">
                    <InputField
                      placeholder="Salary"
                      type="number"
                      name={"salary"}
                      value={employee.salary}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                {/* <div className='ae-formFields'>
                <div className='ae-inputField'>
                  <div className='ae-selectText'>Role</div>
                  <Select options={opt} placeholder="Role" className='ae-select'
                      styles={{
                          control: (baseStyles, state) => ({
                          ...baseStyles,
                          backgroundColor: state.isFocused ?"white":'#F5F6FA',
                          border: 'none',
                          borderRadius: '20px',
                          marginLeft: '8px',
                          marginRight: '0px',
                          fontSize: "14px",
                          padding:"0px",
                          }),
                      }}
                  />
                </div>
                <div className='ae-inputField'>
                  <div className='ae-selectText'>Status</div>
                    <Select options={opt} placeholder="Status" className='ae-select'
                        styles={{
                            control: (baseStyles, state) => ({
                            ...baseStyles,
                            backgroundColor: state.isFocused ?"white":'#F5F6FA',
                            border: 'none',
                            marginLeft: '-8px',
                            marginRight: '7px',
                            borderRadius: '20px',
                            fontSize: "14px",
                            padding:"0px",
                            }),
                        }}
                    />
                </div>
              </div> */}
                <div style={{ color: "red", display: err ? "flex" : "none" }}>
                  Password doesn't matched. Please enter correct password in
                  both fields!
                </div>
                <div className="ae-formFields">
                  <div className="ae-inputField">
                    <InputField
                      placeholder="Password"
                      type="password"
                      onChange={(e) => {
                        setPass(e.target.value);
                      }}
                    />
                  </div>
                  <div className="ae-inputField">
                    <InputField
                      placeholder="Confirm Password"
                      type="password"
                      onChange={(e) => {
                        setConfrmPass(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            <div>
              <div className="ev-btnAdd ev-btn">
                <Gbtn
                  text="Add"
                  func={addEmployeeClick}
                  color="#4ab493"
                  radius="13px"
                  width="130px"
                />
              </div>
              <div className="ev-btnDel ev-btn">
                <Gbtn
                  text="Discard"
                  func={discardOnlclick}
                  color="#F39971"
                  radius="13px"
                  width="130px"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default EmployeeAdd;
